/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m3 15h12v-12h-11.72727273c-.15093924 0-.27272727.12187219-.27272727.27272727zm0 2v11.7272727c0 .1508551.12178803.2727273.27272727.2727273h11.72727273v-12zm26-2v-11.72727273c0-.15085508-.121788-.27272727-.2727273-.27272727h-11.7272727v12zm0 2h-12v12h11.7272727c.1509393 0 .2727273-.1218722.2727273-.2727273zm-25.72727273-16h25.45454543c1.2558182 0 2.2727273 1.01761188 2.2727273 2.27272727v25.45454543c0 1.2551154-1.0169091 2.2727273-2.2727273 2.2727273h-25.45454543c-1.25581816 0-2.27272727-1.0176119-2.27272727-2.2727273v-25.45454543c0-1.25511539 1.01690911-2.27272727 2.27272727-2.27272727z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;